import { post } from '../Services/http'
import { load as loadCart } from '../Actions/Cart.action'
import { submitError } from '../Actions/Checkout.action'

export const ADYEN_DROPIN_NAME = 'Adyen:SE AdyenDropin'

const handleError = (ex, dispatch, reloadCard = false) => {
    if (ex.response) {
        ex.response.json().then((error) => {
            dispatch(submitError(error))
            // reload the cart, it might be changed after validation
            reloadCard && dispatch(loadCart())
        })
    } else {
        dispatch(submitError(ex))
    }
}

export const placeOrder = (pspReference, callback) => (dispatch, getState) => {
    const { payload } = getState().checkout
    payload.pspReference = pspReference
    return post('/api/adyen', payload)
        .then((response) => response.json())
        .then((result) => {
            const details = JSON.parse(result.payload)
            const redirectUrl = result.redirectUrl
            return callback ? callback(details, redirectUrl) : void 0
        })
        .catch((ex) => {
            handleError(ex, dispatch, true)
        })
}

export const initSession = () => (dispatch, getState) => {
    const { payload } = getState().checkout

    return post('/api/adyen/init', payload)
        .then((response) => response.json())
        .then((result) => {
            const details = JSON.parse(result.payload)
            return details
        })
        .catch((ex) => {
            handleError(ex, dispatch, true)
        })
}

export const payments = (data) => (dispatch, getState) => {
    const { payload } = getState().checkout
    payload.paymentMethod = data.paymentMethod
    payload.browserInfo = data.browserInfo
    payload.origin = window.location.origin

    return post('/api/adyen/payments', payload)
        .then((response) => response.json())
        .catch((ex) => {
            handleError(ex, dispatch)
        })
}

export const additionalDetails = (data) => (dispatch, getState) => {
    const { payload } = getState().checkout
    payload.paymentDetails = data

    return post('/api/adyen/payments/details', payload)
        .then((response) => response.json())
        .catch((ex) => {
            handleError(ex, dispatch, true)
        })
}

export const asyncValidate = () => (dispatch, getState) => {
    const { payload } = getState().checkout

    return post('/api/adyen/validate', payload).catch((ex) => {
        handleError(ex, dispatch)
        throw ex
    })
}
